(() => {
  if (window.__themeCollapsibleRowInitialized) return;
  window.__themeCollapsibleRowInitialized = true;

  const ANY_ROW_SELECTOR = 'details[data-collapsible-row]';
  const ROW_SELECTOR = 'details[data-collapsible-row][data-collapsible-single="true"][data-collapsible-group]';
  const CLOSING_ATTR = 'data-collapsible-closing';
  let resizeRaf = null;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setRowContentHeight = (row) => {
    if (!(row instanceof HTMLDetailsElement)) return;

    const bodyInner = row.querySelector('.collapsible-row__body-inner');
    if (!(bodyInner instanceof HTMLElement)) return;

    row.style.setProperty('--collapsible-row-content-height', `${Math.ceil(bodyInner.scrollHeight)}px`);
  };

  const setAllRowHeights = (root = document) => {
    root.querySelectorAll(ANY_ROW_SELECTOR).forEach((row) => {
      setRowContentHeight(row);
    });
  };

  const closeRow = (row) => {
    if (!(row instanceof HTMLDetailsElement) || !row.open) return;

    if (prefersReducedMotion.matches) {
      row.removeAttribute(CLOSING_ATTR);
      row.removeAttribute('open');
      return;
    }

    if (row.hasAttribute(CLOSING_ATTR)) return;

    const body = row.querySelector('.collapsible-row__body');
    if (!(body instanceof HTMLElement)) {
      row.removeAttribute('open');
      return;
    }

    setRowContentHeight(row);
    row.setAttribute(CLOSING_ATTR, 'true');

    let finished = false;
    const cleanup = () => {
      if (finished) return;
      finished = true;

      body.removeEventListener('transitionend', onTransitionEnd);
      row.removeAttribute(CLOSING_ATTR);
      row.removeAttribute('open');
    };

    const onTransitionEnd = (event) => {
      if (event.target !== body || event.propertyName !== 'max-height') return;
      cleanup();
    };

    body.addEventListener('transitionend', onTransitionEnd);
    window.setTimeout(cleanup, 700);
  };

  const closeSiblingRows = (row) => {
    const group = row.getAttribute('data-collapsible-group');
    if (!group || !row.open) return;

    const root = row.closest('.shopify-section') || document;
    const safeGroup = CSS.escape(group);
    const siblings = root.querySelectorAll(`${ROW_SELECTOR}[data-collapsible-group="${safeGroup}"]`);

    siblings.forEach((sibling) => {
      if (sibling !== row && sibling.open) {
        closeRow(sibling);
      }
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const summary = target.closest('summary');
      if (!(summary instanceof HTMLElement)) return;

      const row = summary.parentElement;
      if (!(row instanceof HTMLDetailsElement) || !row.matches(ANY_ROW_SELECTOR)) return;

      if (!row.open || row.hasAttribute(CLOSING_ATTR) || prefersReducedMotion.matches) return;

      event.preventDefault();
      closeRow(row);
    },
    true
  );

  document.addEventListener(
    'toggle',
    (event) => {
      const row = event.target;
      if (!(row instanceof HTMLDetailsElement)) return;
      if (!row.matches(ANY_ROW_SELECTOR)) return;

      setRowContentHeight(row);
      row.removeAttribute(CLOSING_ATTR);

      if (row.matches(ROW_SELECTOR)) {
        closeSiblingRows(row);
      }
    },
    true
  );

  const onResize = () => {
    if (resizeRaf !== null) return;
    resizeRaf = window.requestAnimationFrame(() => {
      setAllRowHeights();
      resizeRaf = null;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setAllRowHeights(), { once: true });
  } else {
    setAllRowHeights();
  }

  window.addEventListener('load', () => setAllRowHeights(), { once: true });
  window.addEventListener('resize', onResize, { passive: true });
})();
